import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    accessToken: '',
    authResponse: '',
    expires: '',
    logoutResponse: '',
    logoutTimeout: null,
    passwordTokenValid: null,
    pending: false,
    refreshToken: '',
    regResponse: '',
    resetResponse: '',
    setNewPwdResponse: '',
    userId: '',
    userLoggedIn: false,
    leadPlanSelected: false,
    trackingDisabled: false,
  };
};

export function dealerLogin(state = defaultState(), action) {
  const { type, payload, error } = action;

  if (type === ActionTypes.LEAD_PLAN_SELECT) {
    return { ...state, leadPlanSelected: true };
  }

  // Request
  if (type === ActionTypes.GET_AUTH_REQUEST) {
    return {
      ...state,
      pending: true,
      authResponse: '',
    };
  }

  if (
    type === ActionTypes.GET_REGISTER_REQUEST ||
    type === ActionTypes.CONFIRM_USER_ACCOUNT_REQUEST ||
    type === ActionTypes.RESEND_ACCOUNT_CONFIRMATION_REQUEST
  ) {
    return {
      ...state,
      pending: true,
      regResponse: '',
    };
  }

  if (type === ActionTypes.RESET_PASSWORD_REQUEST) {
    return {
      ...state,
      pending: true,
      resetResponse: '',
    };
  }

  if (type === ActionTypes.LOGOUT_REQUEST) {
    return {
      ...state,
      pending: true,
      logoutResponse: '',
    };
  }

  if (type === ActionTypes.SET_NEW_PASSWORD_REQUEST) {
    return {
      ...state,
      pending: true,
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.CHECK_PASSWORD_RESET_VALID_REQUEST) {
    return {
      ...state,
      pending: true,
      passwordTokenValid: null,
    };
  }

  // Success
  if (type === ActionTypes.GET_AUTH_SUCCESS) {
    const expires = new Date();
    const { access_token, refresh_token, trackingDisabled } = payload;

    expires.setSeconds(expires.getSeconds() + payload.expires_in);

    return {
      ...state,
      pending: false,
      accessToken: access_token,
      refreshToken: refresh_token,
      expires: expires.getTime(),
      userId: payload.uid,
      userLoggedIn: true,
      authResponse: 'ok',
      trackingDisabled,
    };
  }

  if (
    type === ActionTypes.GET_REGISTER_SUCCESS ||
    type === ActionTypes.RESEND_ACCOUNT_CONFIRMATION_SUCCESS
  ) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      resetResponse: '',
      regResponse: 'ok',
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.RESET_PASSWORD_SUCCESS) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: 'ok',
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.LOGOUT_SUCCESS) {
    return {
      ...defaultState(),
      logoutResponse: 'ok',
    };
  }

  if (type === ActionTypes.SET_NEW_PASSWORD_SUCCESS) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: 'ok',
    };
  }

  if (type === ActionTypes.CHECK_PASSWORD_RESET_VALID_SUCCESS) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: '',
      passwordTokenValid: true,
    };
  }

  if (type === ActionTypes.CONFIRM_USER_ACCOUNT_SUCCESS) {
    let message;

    if (payload.message === 'ALREADY_CONFIRMED') {
      message = 'alreadyConfirmed';
    } else {
      message = 'confirmed';
    }
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: message,
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  // Error
  if (type === ActionTypes.GET_AUTH_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: error.message,
    };
  }

  if (type === ActionTypes.AUTH_RESET) {
    return defaultState();
  }

  if (type === ActionTypes.GET_REGISTER_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      resetResponse: '',
      regResponse: error.message,
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.RESET_PASSWORD_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: error.message,
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.LOGOUT_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: '',
      logoutResponse: error.message,
      setNewPwdResponse: '',
    };
  }

  if (type === ActionTypes.SET_NEW_PASSWORD_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: error.message,
    };
  }

  if (type === ActionTypes.CHECK_PASSWORD_RESET_VALID_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: '',
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: '',
      passwordTokenValid: false,
    };
  }

  if (type === ActionTypes.CONFIRM_USER_ACCOUNT_FAILURE) {
    return {
      ...state,
      pending: false,
      accessToken: '',
      refreshToken: '',
      expires: '',
      userId: '',
      userLoggedIn: false,
      authResponse: '',
      regResponse: 'tokenInvalid',
      resetResponse: '',
      logoutResponse: '',
      setNewPwdResponse: '',
    };
  }

  return state;
}

dealerLogin.blacklist = [
  'authResponse',
  'regResponse',
  'resetResponse',
  'logoutResponse',
  'setNewPwdResponse',
  'passwordTokenValid',
];
